<script setup lang="ts">
import type { BannerType } from '@/types';
import { ref, computed, watch } from 'vue';
import { useLimits } from '@/composables/useLimits';
import { useBanners } from '@/composables/useBanners';
import { useLimitsStore, useAuthStore } from '@/stores';
import { usePlayer } from '@/composables/usePlayer';
import { useRouter } from 'vue-router';
import ExceedModal from '../ExceedModal.vue';
const bannerType: BannerType = 'responsible_gaming';
const { banners, loadingFlag: bannersLoadingFlag, toSetRequest } = useBanners(bannerType);
const router = useRouter();
const limitsStore = useLimitsStore();
const { toSetTimeLimit, loadingFlag } = useLimits();
const { player } = usePlayer();
const authStore = useAuthStore();
const limitsModalFlag = computed(() => limitsStore.limitsModal.sessionFlag);
const currentImage = computed(() => {
    if (banners.value) {
        return banners?.value.find((banner) => banner.name === 'time')?.image || null;
    }
    return null;
});
const visible = ref(false);
watch(limitsModalFlag, (newValue) => {
    visible.value = newValue;
    if (!banners.value) {
        toSetRequest(bannerType);
    }
});
const timeLimitInMinutes = computed(() => {
    const timeLimit = player.value.time_limit;
    if (typeof timeLimit === 'number') {
        return Math.ceil(timeLimit / 60);
    }
    return 0;
});
async function toRedirectToSettings() {
    if (!loadingFlag.value) {
        await toPlayMore();
        router.push('/profile/general/limits');
    }
}
async function toLogout() {
    await toSetTimeLimit({ time_limit: 1 });
    authStore.signOut();
    toCloseModal();
}
async function toPlayMore() {
    let newTimeLimit = player.value.time_limit;
    if (Number(player.value.time_limit) % 60 !== 0) {
        newTimeLimit = Math.ceil(Number(player.value.time_limit) / 60) * 60;
    }
    await toSetTimeLimit({ time_limit: newTimeLimit });
    toCloseModal();
}
function toCloseModal() {
    limitsStore.toSetLimitsData({ modal: false }, 'sessionFlag');
    visible.value = false;
}
</script>
<template>
    <ExceedModal @redirectToSettings="toRedirectToSettings" v-model:visible="visible" :currentImage :loading="bannersLoadingFlag">
        <template #title>{{ $t('session_limit_title') }}</template>
        <template #description>{{ `${$t('session_limit_description')} ${timeLimitInMinutes} ${$t('mins')}.` }}</template>
        <template #buttons>
            <Button :loading="loadingFlag" :label="$t('play_more')" fluid @click="toPlayMore" text class="!border !border-green-400 !p-2 !font-bold uppercase !text-green-400 hover:!bg-green-400/20"></Button>
            <Button :loading="loadingFlag" :label="$t('logout')" fluid @click="toLogout" text class="!border !border-red-400 !p-2 !font-bold uppercase !text-red-400 hover:!bg-rose-400/20"></Button>
        </template>
    </ExceedModal>
</template>
